export default {
    ExternalOrders: {
        addressTips: 'Pickup 类型订单不允许填写收货地址',
        number: '客户订单号/内部订单号',
        Platform: '平台状态',
        Refund: '退款状态',
        Circulation: '流转状态',
        Write: '回写状态',
        Consignee: '收货人姓名',
        Mobile: '手机号',
        Payment: '支付时间',
        Order: '下单时间',
        Create: '创建订单',
        store: '手工下载授权店铺订单',
        byorder: '手工下载授权渠道订单',
        bytime: '手工下载授权店铺订单（按时间）',
        Abnormality: '异常单转正',
        Online: '线上订单号（每行一个订单号,换行输入或以英文逗号,分隔输入 最大允许输入100个单号）',
        enter: '请输入分类名称',
        select: '请选择所属分类',
        form: {
            number: '客户订单号',
            order: '内部订单号',
            Store: '店铺',
            Channel: '渠道',
            Circulation: '流转状态',
            Reason: '流转失败原因',
            Write: '回写状态',
            type: '订单类型',
            source: '订单来源',
            Platform: '平台状态',
            Refund: '退款状态',
            receiving: '平台收货状态',
            Method: '支付方式',
            Mobistatusle: '支付状态',
            Buyer: '买家留言',
            Merchant: '商家备注',
            products: '商品数',
            amount: '商品总金额',
            Discount: '优惠合计',
            Total: '应收总金额',
            actual: '买家实付',
            undertakes: '商家承担优惠金额',
            Preferential: '三方承担优惠金额',
            Freight: '运费',
            nickname: '买家昵称',
            Flag: '旗帜',
            Consignee: '收货人姓名',
            Mobile: '手机号',
            Shipping: '收货地址',
            Invoice: '发票类别',
            header: '发票抬头',
            content: '发票内容',
            Payment: '支付单号',
            Logistics: '物流方式',
            Three: '三方下单时间',
            time: '支付时间',
            Pull: '拉单时间',
            Confirm: '确认收货时间',
            Please: '请选择异常单',
        },
        dialog: {
            orders: '下载订单',
            number: '按订单号下载（支持多个订单，逗号隔开）',
            Downloadtime: '按时间下载',
            Store: '店铺',
            OrderNo: '订单号',
            Timetype: '时间类型',
            Time: '时间',
            select: '请选择店铺',
            enter: '请输入订单号',
            type: '请选择时间类型',
            Please: '请选择时间',
            placement: '下单时间',
            Payment: '支付时间',
            Notification: '通知配货时间',
            Last: '最后修改时间',
        },
        download: {
            Add: '添加店铺',
            Store: '店铺名称',
            selected: '未选择店铺',
            Start: '开始时间',
            Within: '与结束时间相隔3天内',
            End: '结束时间',
            days: '与开始时间相隔3天内',
            content: '请输入内容',
            Download: '立即下载',
            ID: 'ID或单号不能为空',
            You: '最大只能输入100个',
            Please: '请选择店铺',
            time: '请选择开始时间',
            select: '请选择结束时间',
            order: '手工下载订单',
        },
        newAdd: {
            OrderDate: '订单日期',
            OriginalWarehouse: '原始发货仓',
            Ouantity: '订单数量',
            AccountCode: '账户编码',
            TaxCode: '税号',
            Currency: '货币',
            DeliveryName: '姓名',
            DeliveryPhone: '电话',
            mail: '邮件',
            DeliveryAddress1: '邮寄地址1',
            DeliveryAddress2: '邮寄地址2',
            DeliveryState: '州',
            DeliveryPostcode: '邮编',
            DeliverySuburb: '邮寄地区',
            DestinationCountry: '国家',
            emailAddress: '邮箱地址',
            comments: '订单备注',
            buyerRemarks: '买家备注',
            ShippingMethod: '邮寄方式',
            receivingInformation: '买家及收货信息',
            chooseShippingAddress: '选择收件地址',
            anomalyDetected: '检测到收件地址存在异常，请核实或选择建议地址。',
            anomalyDetected2: '地址验证服务暂时不可用，请手动编辑原始地址。',
            anomalyDetected3Pre: '系统无法生成推荐地址，标注 ! 的字段疑似有误，请前往',
            anomalyDetected3Post: '核实并手动更正。',
            currentAddress: '当前地址',
            suggestion: '建议地址',
            RECOMMENDED: '推荐',
            verifiedInfo: '已验证信息',
            buyerAndReceivingInfo: '买家及收件信息',
            editAddress: '编辑地址',
            doneEdit: '完成编辑',
            useOriginal: '使用原始地址',
            useSuggestion: '使用建议地址',
            selectCurrentAddressTip: '请选择 当前地址',
            ProductID: '产品ID',
            ProductSKU: '产品SKU',
            ProductName: '产品名',
            Barcode: '条形码',
            Supplier: '供应商',
            ExternalSku: '外部产品SKU',
        },
        // ExternalOrders 页面
        page: {
            orderIdLabel: '订单号',
            orderStatusLabel: '订单状态',
            fulfillmentLabel: '履约状态',
            paymentStatusLabel: '付款状态',
            warehouseLabel: '发货仓',
            eligibleLabel: '满足条件',
            processingStatusLabel: '处理状态',
            processingLabel: '处理中',
            exceptionLabel: '异常',
            processingStatusException: '异常',
            processingStatusProcessing: '处理中',
            processingStatusWriteback: '已回写',
            processingStatusUncaptured: '未抓单',
            retryBtn: '重试',
            pullBtn: '抓单',
            dialogTitle: '异常',
            dialogTip: '请解决问题后点击 Retry 重新处理此订单。',
            errorMessageLabel: '错误信息：',
            closeBtn: '关闭',
        },
        EDI: {
            summaryException: '异常',
            summaryAwaitingClientApproval: '等待客户审批',
            summaryInProgress: '处理中',
            summaryComplete: '完成',
            filterOrderNo: '订单号',
            filterStore: '店铺',
            filterRetailer: '零售商',
            filterEdiStatus: 'EDI状态',
            filterActionOwner: '处理负责人',
            columnOrderNo: '订单号',
            columnRetailer: '零售商',
            columnCustomer: '客户',
            columnStore: '店铺',
            columnEdiStatus: 'EDI状态',
            columnActionOwner: '处理负责人',
            columnReceived: '接收时间',
            columnAction: '操作',
            detailCurrentStep: '当前步骤',
            detailActionOwner: '处理负责人',
            detailOrderNumbers: '订单编号',
            detailRetailerPo: '零售商PO',
            detailClientErpNo: '客户ERP单号',
            detailCsgOrderNo: 'CSG订单号',
            detailProcessingTimeline: '处理时间线',
            detailDeliveryAddress: '收货地址',
            detailRecipient: '收件人',
            detailPhone: '电话',
            detailAddress: '地址',
            detailSuburb: '邮寄地区',
            detailStatePostcode: '州 / 邮编',
            detailCountry: '国家',
            detailApproveAndContinue: '审核进入下一步',
            detailOrderLines: '订单行',
            detailItems: '商品',
            detailSku: '条形码',
            detailQty: '数量',
            detailMatch: '匹配状态',
            MatchStatus1: '匹配',
            MatchStatus2: '不匹配',
            detailEdiPayload: 'EDI报文',
            detailInternalOnly: '仅内部',
            detailClose: '关闭',
        }
    }
};
